import type { FunctionComponent, ReactNode } from 'react';
import { useMemo, useReducer } from 'react';

import MetadataContext from './MetadataContext';
import { getActions } from './actions';
import { initialState, reducer } from './reducer';
import * as selectors from './selectors';

const MetadataProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const actions = useMemo(() => getActions(dispatch), [dispatch]);

  return (
    <MetadataContext.Provider value={{ actions, selectors, state }}>
      {children}
    </MetadataContext.Provider>
  );
};

export default MetadataProvider;
